import React from 'react'
import { useIntl } from 'react-intl'

import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import { middleDotSeparatorMessage } from 'LuxKit/intl/separators'

interface Props {
  startLocation?: string | null
  typeOfExperience?: string
  size?: 'small' | 'medium' | 'large'
}

function BookmarkLocationWithTypeOfExperience({
  startLocation,
  typeOfExperience,
  size = 'large',
}: Props) {
  const intl = useIntl()
  const sep = intl.formatMessage(middleDotSeparatorMessage)
  return (
    <CaptionTextBlock variant={size} lineClamp={2}>
      {typeOfExperience
        ? intl.formatMessage({ id: 'iBpBzAOMtdtcSvtlVUCq', defaultMessage: '{location} {sep} {typeOfExperience}', description: 'Bookmarked location with separator and experience type' }, { location: startLocation, sep, typeOfExperience })
        : startLocation}
    </CaptionTextBlock>
  )
}

export default BookmarkLocationWithTypeOfExperience
